import React from "react";
import { SavedRow, } from "./types";
import { PropertyAPI } from "./lib/property-api";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { PropertyImage } from "./types";
import { dd, toS3Image } from "./Utils";
import { PropertySource } from "./lib/property-api";
import "react-image-gallery/styles/css/image-gallery.css";
import { get_source } from "./lib/source";
interface ImageGalleryEntry {
  original: string;
  thumbnail: string;
  order?: number;
}

interface Props {
  property_id: string;
  source: PropertySource;
}
function ImageThumbnail(props: Props) {
  //const [isStaging, setIsStaging] = React.useState<boolean>(false);
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [error, setError] = React.useState<string | null>(null);
  const [images, setImages] = React.useState<ImageGalleryEntry[]>([]);
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());
  React.useEffect(() => {
    (async () => {
      setPropertyID(props.property_id);
      let tmp: SavedRow|null;
      tmp = await api.get_property_by_source(props.property_id,get_source());
      if (!tmp){
        setError("Unable to find the listing you were looking for.");
        return;
      }
      setError(null);
      dd({ propertyID, error });
      let img_list: ImageGalleryEntry[] = [];
      for (const media of tmp.Media) {
        try {
          let img: PropertyImage = toS3Image(media.MediaURL, media.Order, get_source());
          img_list.push({
            original: img.src.toString(),
            thumbnail: img.thumb.toString(),
            order: img.order,
          });
        } catch (err) {
          console.error(err);
        }
      }
      if (img_list.length) {
        img_list = img_list.sort(
          (a: ImageGalleryEntry, b: ImageGalleryEntry) => {
            if(a.order !== undefined && b.order !== undefined){
              return a.order - b.order;
            }
            return 0;
          }
        );
        img_list = img_list.map((v: ImageGalleryEntry) => {
          return {
            original: v.original,
            thumbnail: v.thumbnail,
          };
        });
      }
      setImages(img_list);
    })();
  }, [props,]);
  return (
    <>
      {images.length > 0 && <img src={images[0].thumbnail}></img>}
    </>
  );
}

export default ImageThumbnail;
